export const SUMMARY_STEP_ROUTE = 'podsumowanie';
